import { http } from "@/api/index";

const Qs = require("qs");

/**
 * @summary Solicita o último registro de eventos de um conjunto de configuração de eventos.
 * @param {Array} eventSettingsIds Array com os ids dos sinais de eventos.
 * @returns Array com os últimos eventos disponíveis.
 */
const GetLastRecords = function(eventSettingsIds)
{
	return http.post("/EventsRecords/LastRecords", eventSettingsIds);
};

/**
 * @summary Solicita os registro de eventos de um conjunto de configuração de eventos para um período.
 * @param {object} eventRecordsParams Objeto contendo os Ids de configuração dos eventos
 *  e o período de consulta selecionado.
 * @returns Array com os eventos disponíveis.
 */
const GetRecords = function(eventRecordsParams)
{
	const userDateTimeFormat = "dd/MM/yyyy";
	return http.post("/EventsRecords", eventRecordsParams,
		{ headers: { DateTimeFormat: userDateTimeFormat } });
};

export default { GetRecords, GetLastRecords };